<div class="d-flex justify-content-center spinner-icon">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
</div>
